import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { SearchPageBrandsOffFaireText } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandsOffFaireText/SearchPageBrandsOffFaireText";
import { useSearchPageSearchStringFullyTranslated } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageSearchResultsText/__internal__/useSearchPageSearchStringFullyTranslated";
import { useSearchPageShouldShowEscapeHatchText } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageSearchResultsText/__internal__/useSearchPageShouldShowEscapeHatchText";
import { useSearchPageShouldShowRelatedResultsText } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageSearchResultsText/__internal__/useSearchPageShouldShowRelatedResultsText";
import { useSearchPageShouldShowSpellCheckEscapeHatchText } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageSearchResultsText/__internal__/useSearchPageShouldShowSpellCheckEscapeHatchText";
import { SearchPageSpellCheckEscapeHatch } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageSpellCheckEscapeHatch/SearchPageSpellCheckEscapeHatch";
import { useSearchPageProductOrParsedSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/useSearchPageProductOrParsedSearchString";
import { useSearchPageShouldShowBrandSearch } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/useSearchPageShouldShowBrandSearch";
import { useSearchPageShowNoProductResults } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageShowNoProductResults";
import { useSearchPageFormattedTotalPrimaryResultsCount } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Filters/useSearchPageFormattedTotalPrimaryResultsCount";
import { useSearchPageTotalPrimaryResultsCount } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Filters/useSearchPageTotalPrimaryResultsCount";
import { useSearchPageBrandsOffFaireQuery } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageBrandsOffFaireQuery";
import { useSearchPageQueryIsLoading } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
import { FullSentenceResultCountSubHeader } from "@faire/deprecated-retailer-visitor-shared/views/search/utils";
import { MediumFormatting } from "@faire/web/common/localization/formatting";
import { Column, Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { ResponsiveProp } from "@faire/web/slate/Theme/ResponsiveProp";
import { Typography, TypographyVariants } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";

export const SearchPageSearchResultsText: React.FC = () => {
  const loading = useSearchPageQueryIsLoading();
  const brandsOffFaireQuery = useSearchPageBrandsOffFaireQuery();
  const productOrParsedSearchString =
    useSearchPageProductOrParsedSearchString();
  const searchStringFullyTranslated =
    useSearchPageSearchStringFullyTranslated();
  const shouldShowBrandSearch = useSearchPageShouldShowBrandSearch();
  const shouldShowRelatedResultsText =
    useSearchPageShouldShowRelatedResultsText();
  const shouldShowSpellCheckEscapeHatchText =
    useSearchPageShouldShowSpellCheckEscapeHatchText();
  const totalPrimaryResultsFormatted =
    useSearchPageFormattedTotalPrimaryResultsCount();
  const totalPrimaryResultsCount = useSearchPageTotalPrimaryResultsCount();
  const shouldShowEscapeHatchText = useSearchPageShouldShowEscapeHatchText();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const typographyVariant: ResponsiveProp<TypographyVariants> =
    isLoggedInRetailer || !productOrParsedSearchString
      ? {
          mobileAndAbove: "pageHeaderSerifRegular",
          desktopAndAbove: "displaySSerifRegular",
        }
      : "paragraphSansRegular";

  if (brandsOffFaireQuery) {
    return (
      <Column>
        <Spacer height="2x" />
        <HeaderTypography variant="pageHeaderSerifRegular">
          <SearchPageBrandsOffFaireText
            brandsOffFaireQuery={brandsOffFaireQuery}
          />
        </HeaderTypography>
      </Column>
    );
  }

  if (shouldShowBrandSearch) {
    return (
      <HeaderTypography
        variant={
          isLoggedInRetailer ? "pageHeaderSerifRegular" : typographyVariant
        }
      >
        {isLoggedInRetailer ? (
          <StrictLocalMsg
            id="V2/uOI"
            defaultMessage="More Results"
            description={{
              text: "Title of the search results page indicating the section below contains more search results.",
            }}
          />
        ) : (
          <StrictLocalMsg
            id="6hhHHF"
            defaultMessage="All Results"
            description={{ text: "Title of the search results page" }}
          />
        )}
      </HeaderTypography>
    );
  }

  if (productOrParsedSearchString.trim() === "") {
    return (
      <HeaderTypography variant={typographyVariant}>
        <StrictLocalMsg
          id="k8Gvox"
          defaultMessage="Results"
          description={{ text: "Title of the search results page" }}
        />
      </HeaderTypography>
    );
  }

  if (shouldShowRelatedResultsText) {
    return (
      <HeaderTypography variant={typographyVariant}>
        <StrictLocalMsg
          id="CouKIj"
          defaultMessage="Related results"
          description={{
            text: "Header on the search results page for products that only match some of the search keywords",
          }}
        />
      </HeaderTypography>
    );
  }

  if (!isLoggedInRetailer) {
    return (
      <ResponsiveContentV2
        mobile={
          <FullSentenceResultCountSubHeader
            typographyVariant="pageHeaderSerifRegular"
            loading={loading}
            totalPrimaryResultsFormatted={totalPrimaryResultsFormatted}
            totalPrimaryResultsCount={totalPrimaryResultsCount}
            searchStringFullyTranslated={searchStringFullyTranslated}
          />
        }
      />
    );
  }

  if (shouldShowSpellCheckEscapeHatchText) {
    return (
      <HeaderTypography variant={typographyVariant}>
        <StrictLocalMsg
          id="iDVp4z"
          defaultMessage="Showing results for {searchStringFullyTranslatedSentence}"
          description={{
            text: "Title of the search results page after searching for {searchStringFullyTranslatedSentence}",
            img: "https://cdn.faire.com/fastly/1ddcb0f3718936564ca62bf84031dd686126ceb30894926808bd2246f3ce9992.png",
          }}
          values={{
            searchStringFullyTranslatedSentence: searchStringFullyTranslated,
          }}
        />
        &nbsp;|&nbsp;
        <SearchPageSpellCheckEscapeHatch />
      </HeaderTypography>
    );
  }

  if (shouldShowEscapeHatchText && isLoggedInRetailer) {
    return (
      <Column>
        <Spacer height="2x" />
        <HeaderTypography variant={typographyVariant}>
          <StrictLocalMsg
            id="5GioQz"
            defaultMessage="Showing results for {searchStringFullyTranslatedSentence}"
            description={{
              text: "Title of the search results page after searching for {searchStringFullyTranslatedSentence}",
              img: "https://cdn.faire.com/fastly/d8f44e29aff3533905df0b3c9d2a39a2869c8909ca7c8ee03b2c0aacafb70a59.png",
            }}
            values={{
              searchStringFullyTranslatedSentence: searchStringFullyTranslated,
            }}
          />
        </HeaderTypography>
      </Column>
    );
  }

  if (isLoggedInRetailer) {
    return (
      <ResponsiveContentV2
        mobile={
          <Row>
            <MobileSearchResultsHeader
              searchStringFullyTranslated={searchStringFullyTranslated}
            />
          </Row>
        }
        tabletAndAbove={
          <HeaderTypography variant={typographyVariant}>
            <StrictLocalMsg
              id="zcRQvR"
              defaultMessage="Results for {searchStringFullyTranslatedSentence}"
              description={{
                text: "Title of the search results page after searching for {searchStringFullyTranslatedSentence}",
              }}
              values={{
                searchStringFullyTranslatedSentence:
                  searchStringFullyTranslated,
              }}
            />
          </HeaderTypography>
        }
      />
    );
  }

  return (
    <HeaderTypography variant={typographyVariant}>
      <StrictLocalMsg
        id="zcRQvR"
        defaultMessage="Results for {searchStringFullyTranslatedSentence}"
        description={{
          text: "Title of the search results page after searching for {searchStringFullyTranslatedSentence}",
        }}
        values={{
          searchStringFullyTranslatedSentence: searchStringFullyTranslated,
        }}
      />
    </HeaderTypography>
  );
};

const MobileSearchResultsHeader: React.FC<{
  searchStringFullyTranslated: string;
}> = ({ searchStringFullyTranslated }) => {
  const showNoSearchResultsContainer = useSearchPageShowNoProductResults();

  if (showNoSearchResultsContainer) {
    return null;
  }

  return (
    <Column>
      <Spacer height="1x" />
      <HeaderTypography variant="paragraphSansRegular">
        <StrictLocalMsg
          id="isJqtl"
          defaultMessage="Results for <BoldFormatting>{searchStringFullyTranslatedSentence}</BoldFormatting>"
          description={{
            text: "Title of the search results page after searching for {searchStringFullyTranslatedSentence}",
            img: "https://cdn.faire.com/fastly/479f860b33691453319b90de80432c16b646a80fbc1e22c1f9d197e6b66470ad.png",
          }}
          values={{
            BoldFormatting: MediumFormatting,
            searchStringFullyTranslatedSentence: searchStringFullyTranslated,
          }}
        />
      </HeaderTypography>
    </Column>
  );
};

const HeaderTypography = styled(Typography).attrs({
  role: "heading",
})`
  &&& {
    ${responsiveMediaQueries.tabletAndAbove} {
      margin: 0;
    }
  }
`;
